module.exports = __webpack_public_path__ + "img/dog_icon.12034689.svg";